import React from "react";

import NewItemButton from "../NewItemButton";
import { useUnifiedRegistry } from "../unified-registry-context";
import ViewToggle, { ViewMode } from "../ViewToggle";

import DateFilter from "./DateFilter";
import TagsFilter from "./TagsFilter";
import TypeFilter from "./TypeFilter";

import UserFilter from "@/components/Changelog/FilterBar/UserFilter";
import EntityStarButton from "@/components/EntityStarButton";
import { ClearFiltersButton, FilterBarContainer, FilterGroup } from "@/components/ui/FilterBar";
import { EntityType } from "@/queries";

export interface FilterState {
  selectedTypes: EntityType[];
  selectedDateRange: { start?: string; end?: string } | null;
}

export interface FilterChangeEvent {
  type: "types" | "dateRange" | "clear";
  value?: unknown;
}

interface FilterBarProps {
  viewMode?: ViewMode;
  onViewModeChange?: (mode: ViewMode) => void;
  currentFolderId: number | null;
  workspaceId?: number | null;
}

const FilterBar: React.FC<FilterBarProps> = ({
  viewMode = "grid",
  onViewModeChange,
  currentFolderId,
  workspaceId,
}) => {
  const registry = useUnifiedRegistry();

  const leftSection = (
    <>
      <FilterGroup>
        <TypeFilter />
        <TagsFilter value={registry.tags} onChange={tags => registry.setTags(tags)} />
        <DateFilter />
        <UserFilter
          value={registry.selectedUserId}
          onChange={userId => registry.setSelectedUserId(userId)}
        />
      </FilterGroup>
      <ClearFiltersButton
        onClick={() => registry.clearAllFilters()}
        show={registry.hasActiveFilters}
      />
    </>
  );

  const rightSection = (
    <>
      {currentFolderId !== null && (
        <EntityStarButton
          entityType={EntityType.FOLDER}
          entityId={currentFolderId}
          workspaceId={workspaceId ?? undefined}
        />
      )}
      {onViewModeChange && <ViewToggle currentView={viewMode} onViewChange={onViewModeChange} />}
      <NewItemButton currentFolderId={currentFolderId} workspaceId={workspaceId} />
    </>
  );

  return (
    <FilterBarContainer className="mb-1" leftSection={leftSection} rightSection={rightSection} />
  );
};

export default FilterBar;
